import React, { useContext, useEffect, useState } from "react";
// UNINSTALL- Added but not --saved
//import concat from "concat-stream")
//import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useHistory, useParams } from "react-router-dom";
import { AuthContext } from "../../helpers/AuthContext";
import MyInstancesLeftSidebar from "../essentials/MainDashboardLeftSidear";
import PageHeaderWithBreadcrumbs from "../../components/PageHeaderWithBreadcrumbs";
import { useFormik, Formik, Field, Form, ErrorMessage } from "formik";
import { ToastContainer, toast } from 'react-toastify'

/* ICONS */
import TitleIcon from '@mui/icons-material/Title';
import DescriptionIcon from '@mui/icons-material/Description';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import ForumIcon from '@mui/icons-material/Forum';
import PermMediaIcon from '@mui/icons-material/PermMedia';
import BrushIcon from '@mui/icons-material/Brush';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import { getBrowserTimeZone, listSupportedTimeZones } from "../../utils/timezone";

function CreatePost() {
  let { id } = useParams();

  const { authState } = useContext(AuthContext);
  const [title, setTitle] = useState('')
  const [postText, setPostText] = useState('')
  const [instanceUniqueId, setinstanceUniqueId] = useState('')
  const [postObject, setPostObject] = useState('')
  const [chatRoomId, setChatRoomId] = useState('')
  const [typeOfIndustry, setTypeOfIndustry] = useState('promo-company')
  const [desiredAvatarSelection, setDesiredAvatarSelection] = useState('brand_logo')
  const [customUploadedBrandLogo, setCustomUploadedBrandLogo] = useState(null)
  const [predesignedChatStyle, setPredesignedChatStyle] = useState('modern')
  const [customUploadedAvatarImages, setCustomUploadedAvatarImages] = useState(null)
  const [goalForEliteCore, setGoalForEliteCore] = useState('goals')
  const WhatAvatarSelectionDoesTheLiveChatUse = desiredAvatarSelection;
  const [message, setMessage] = useState('');
  const [typeOfCore, setTypeOfLiveChat] = useState("promo-company");
  const [timezone, setTimezone] = useState(getBrowserTimeZone());
  const timeZoneOptions = listSupportedTimeZones();

  const initialValues = {
    title: "",
    instanceUniqueId: "",
    typeOfIndustry: "",
  };

  // Radio selection 
  const handleDesiredAvatarSelectionChange = e => {
    e.persist();
    setDesiredAvatarSelection(e.target.value);
  };

  const handleTypeOfLiveChatChange = e => {
    e.persist();
    setTypeOfLiveChat(e.target.value);
  };

  let history = useHistory();

  useEffect(() => {
    if (!localStorage.getItem("accessToken")) {
      history.push("/login");
    } else {
      axios.get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/byId/${id}`).then((response) => {
        setPostObject(response.data);
        })
    }
  });

  const onSubmit = (data) => {
    // Verify unique core ID doesn't already exist
    axios
    .get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/verifyinstanceUniqueIdexists`, {
      params: {
        instanceUniqueIdToCheck: data.instanceUniqueId
      }
    }).then(instanceUniqueIdStatus => {
      // If the email exists
      if(instanceUniqueIdStatus.data == true){
        toast.error("The unique core ID provided is already in use.", {
          toastId: 1
        })
      // If the email doesn't exist
      } else if (instanceUniqueIdStatus.data == false){
        const newInstanceData = new FormData()
        newInstanceData.append('id', id)
        newInstanceData.append('instanceName', data.title)
        newInstanceData.append('instanceUniqueId', data.instanceUniqueId.toLowerCase())
        newInstanceData.append('typeOfIndustry', typeOfIndustry)
        newInstanceData.append('typeOfCore', typeOfCore)
        newInstanceData.append('timezone', timezone)
        
        var meggedObj = {}
        // add the form key/value pairs
        for (var pair of newInstanceData.entries()) {
          meggedObj[pair[0]] = pair[1];
          //alert(pair[0] + " " + pair[1]);
        }

        axios
          .post(`${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/get-started-wizard`, meggedObj, {
            headers: { 
              accessToken: localStorage.getItem("accessToken"),
            }
          })
          .then((response) => {
            history.push("/instance/" + data.instanceUniqueId.toLowerCase());
          }); 
        }
      })
  };

  const instanceUniqueIdRegExp = /^[\a-zA-Z-]+$/
  const validationSchema = Yup.object().shape({
    title: 
    Yup.string()
      .min(3, "Your business name must be a minimum of 3 characters.")
      .max(80, "Your business name must be a maximum of 80 characters.")
      .matches(/^[-a-zA-Z0-9-()]+(\s+[-a-zA-Z0-9-()]+)*$/, "Your business name may only contain letters and numbers.")
      .required("A business name is required.")
      .typeError("You must assign a business name that is between 3 to 50 characters."),
    instanceUniqueId: 
    Yup.string()
      .min(4, "Your unique core ID must be a minimum of 4 characters.")
      .max(30, "Your unique core ID must be a maximum of 30 characters.")
      .matches(instanceUniqueIdRegExp, "Your unique core ID must only contain letters and dashes.")
      .required("A unique core ID is required.")
      .typeError("Your unique core id must not contain spaces or special characters and be between 4 to 20 characters.")
  });

  return (
<div className="ec-app-instances">
    <MyInstancesLeftSidebar/>
    <ToastContainer/>
    <div className="rightSide">
      <div className="options-container launch-instance fade-in-effect-usability">
        <div className="options-inner-container">
        <Formik 
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          <Form className="form-design-settings">
          <PageHeaderWithBreadcrumbs title="Launch your new live core." breadcrumb="Launch your new instance"/>
          <div className="get-started-introduction-paragraph">
            <span className="instance-badge-step-two">Step #2</span>
            <div className="column-25">
              <ForumIcon/>
            </div>
            <div className="column-75">
              <p>You've arrived at the live core creation form. Here we kindly ask you to provide a few brief details about your business, as well as the type of live core that you're interested in creating and implementing on your website or application.</p>
            </div>
          </div>
          
          <fieldset>
            <div className="field-column-half">
              <div className="field-column-inner">
                <label>What is the name of your business? <span className="required-mark">*</span></label>
                <ErrorMessage name="title" component="span" />
                <Field
                  autocomplete="off"
                  id="inputCreatePost"
                  name="title"
                  placeholder="My Live Core"
                />
              </div>
            </div>
            <div className="field-column-half">
              <div className="field-column-inner">
                <label>Please assign a core unique ID <span className="required-mark">*</span></label>
                <div className="whats-this">
                  <LiveHelpIcon/>
                  <div className="whats-this-explaination">
                    <p>Your unique core ID is used to track every core that is launched. This field is not displayed to visitors, it is purely used as a method of tracking. For example, if your business was called "Elite Core", an ideal unique core ID would be "elite-core"</p>
                  </div>
                </div>
                <ErrorMessage name="instanceUniqueId" component="span" />
                <Field
                  autocomplete="off"
                  id="inputCreatePost"
                  name="instanceUniqueId"
                  placeholder="my-live-core"
                />
              </div>
            </div>
          </fieldset>

          { /* TYPE OF LIVE CORE SELECTION */ }
          <fieldset>
            <div className="field-column-inner">
            <div className="radioSelection" role="group" aria-labelledby="my-radio-group">
            <label id="my-radio-group"><ForumIcon></ForumIcon> Which type of core, would you like to launch?</label>

            <div className="relativeRadioImage">

            <img className="radio-icons" src="/elite-core-icons/core-selection-promo-company.png"/>

              <label>
              <Field
                value="promo-company"
                type="radio"
                aria-label="userHasSelectedAvatar"
                label="Avatar"
                className="radio-input-50"
                onChange={handleTypeOfLiveChatChange}
                checked={ typeOfCore === "promo-company"}
              />
              <span className="radio-text-50">Promo company</span>
              <span className="radio-text-pricing-line-2">$99/monthly</span>

              </label>
              </div>

            </div>
          </div>
          </fieldset>


          <fieldset>
            <div className="field-column-inner">
            <label><LocationCityIcon></LocationCityIcon> Which industry best relates to your live core?</label>
            <ErrorMessage name="typeOfIndustry" component="span" />
            <Field value={typeOfIndustry} as="select" name="typeOfIndustry" onChange={(e) => setTypeOfIndustry(e.target.value)}>
              <option value="promo-company">Promo company</option>
              <option value="awards-c0mpany">Awards company</option>
              <option value="other">Other</option>
            </Field>
            </div>
          </fieldset>   

          <fieldset>
            <div className="field-column-inner">
            <label><LocationCityIcon></LocationCityIcon> Company timezone</label>
            <Field value={timezone} as="select" name="timezone" onChange={(e) => setTimezone(e.target.value)}>
              {timeZoneOptions.map((timeZoneValue) => (
                <option key={timeZoneValue} value={timeZoneValue}>{timeZoneValue}</option>
              ))}
            </Field>
            </div>
          </fieldset>

          <button className="elite-btn" type="submit"> Create instance</button>
      </Form>
      </Formik>
      </div>
      </div>
      </div>
    </div>


  );
}

export default CreatePost;
